module.exports = __webpack_public_path__ + "img/worksbot_img19112530.072b6500.jpg";